import Container from '@components/Container/basic-container';
import React, { useEffect } from 'react';
import { getPrevPath } from 'utils/pathUtils';
import { useGlobalContext } from 'contexts';
import { ROUTE_NAMES } from 'utils/routes';
import useEvents from 'hook/useEvents';
import { TraderEventType } from '@utils/eventsConstant';

const privacyPolicyUrl = 'https://www.ninjacart.com/privacy-policy/';

export const iframeStyle = {
  border: 0,
  height: 'calc(100vh - 50px)',
};

function PrivacyPolicy() {
  const { toggleHamBurger } = useGlobalContext();
  let prevPath = ROUTE_NAMES.DASHBOARD;
  const { triggerEvent } = useEvents();

  if (typeof window !== 'undefined') {
    prevPath = getPrevPath(window.location.search);
  }

  useEffect(() => {
    triggerEvent(TraderEventType.Generic_event, {
      eventName: 'Privacy_policy_success',
    });
  }, []);

  const onBack = React.useCallback(() => {
    toggleHamBurger(false);
  }, []);

  return (
    <Container
      isBackButton
      childClassName="bg-gray-200"
      onBack={onBack}
      backUrl={prevPath}
      //backUrl={!isEmpty(authData) ? '/' : '/login'}
      headerTitle="Privacy Policy"
    >
      <iframe
        frameBorder="0"
        height="100%"
        src={privacyPolicyUrl}
        style={iframeStyle}
        title="Privacy Policy"
        width="100%"
      />
    </Container>
  );
}

export default PrivacyPolicy;
